import { Module } from 'vuex'
import { EventPayload } from '@/ts-definitions'
import { RootStore } from '../rootStore'

export type ConfigStore = {
	isNewAuthWorkflow: boolean
	// scheduledMaintenance not implemented yet
	// update App.vue in the next maintenance window
	scheduledMaintenance?: {
		message: string
		startTime: number
		endTime: number
	}
}

const initialState: ConfigStore = {
	isNewAuthWorkflow: true,
	scheduledMaintenance: {
		message:
			'<b>Scheduled Maintenance</b> <br /> Our product search will be down for scheduled maintenance on (11/4) from 05:00 PM to 06:00 PM PDT',
		startTime: new Date('2022-11-03T00:00:00-07:00').getTime(),
		endTime: new Date('2022-11-04T20:00:00-07:00').getTime(),
	},
}

type ConfigNamespace = 'config'

type ConfigNewAuthWorkflowMutation = EventPayload<
	`${ConfigNamespace}/setNewAuthWorkflow`,
	Partial<ConfigStore['isNewAuthWorkflow']>
>

type ConfigScheduledMaintenanceMutation = EventPayload<
	`${ConfigNamespace}/setScheduledMaintenance`,
	Partial<ConfigStore['scheduledMaintenance']>
>

export type ConfigMutations =
	| ConfigNewAuthWorkflowMutation
	| ConfigScheduledMaintenanceMutation

export const configStore: Module<ConfigStore, RootStore> = {
	namespaced: true,
	state: () => ({ ...initialState }),
	mutations: {
		setNewAuthWorkflow(state, { payload }: ConfigNewAuthWorkflowMutation) {
			state.isNewAuthWorkflow = payload
		},
		setScheduledMaintenance(
			state,
			{ payload }: ConfigScheduledMaintenanceMutation
		) {
			state = Object.assign(state, payload)
		},
	},
}
